import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import common from "./modules/common"
import browse from "./modules/browse"
import authentication from './modules/authentication'
import hospemployee from './modules/hospemployee'
import ui from './modules/ui'
import dashboard from './modules/dashboard'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth:authentication,
    uicomponents:ui,
    hospemployee:hospemployee,
    common:common,
    browse:browse,
    dashboard:dashboard
  },
  state: {
    layout: '',
    loggedin: false,
    dashboardTitle: 'Dash Board',
    menuData:null,
    currency: 'SAR',
    officeId: [],
    hType: []
  },
  actions,
  mutations,
  getters
})
export function createStore() {
  return store
}
//  For inheriting in other modules
export default store


// WEBPACK FOOTER //
// ./src/store/index.js